import { render } from "./edit-content.vue?vue&type=template&id=7d9ff061&ts=true"
import script from "./edit-content.vue?vue&type=script&lang=ts"
export * from "./edit-content.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__